function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { AsyncButtonEl } from "common/components/async-button";
import { TooltipEl } from "common/components/tooltip";
import asyncButtonStyleOverride from "./async-button-override.inline.styl";
export function template() {
  const projectStoreHasFetchedValue = this.helpers.projectStoreFetched();
  const {
    t
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx("span", { sel: ".mp-sharing-status-button-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.attr("tooltip-text") && this.helpers.isDisabled() ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: this.attr("tooltip-text"),
    offset: 10,
    "body-level": true
  } }) : null, !this.attr("hide-share-button") && /* @__PURE__ */ jsx(ButtonEl, { sel: ".left", class: {
    "secondary-theme": this.attr("theme") === "secondary",
    "fully-rounded": this.attr("theme") === "tertiary"
  }, attrs: _objectSpread({
    elref: "sharingStatusButton",
    theme: this.attr("theme"),
    disabled: this.helpers.isDisabled()
  }, this.attr("tooltip-text") && !this.helpers.isDisabled() ? {
    tooltip: {
      text: this.attr("tooltip-text")
    }
  } : {}), on: {
    click: this.helpers.handleClick
  } }, t("common.share")), /* @__PURE__ */ jsx(AsyncButtonEl, { class: {
    "fully-rounded": this.attr("hide-share-button") || this.attr("theme") === "tertiary",
    "has-share-button": !this.attr("hide-share-button")
  }, params: _objectSpread(_objectSpread({
    asyncAction: this.helpers.copyLink,
    elref: "sharingCopyLinkSplitButton",
    theme: this.attr("theme")
  }, this.attr("show-shortlink-text") ? {} : {
    icon: !projectStoreHasFetchedValue ? "spinner" : "link"
  }), {}, {
    disabled: !projectStoreHasFetchedValue,
    "style-override": asyncButtonStyleOverride,
    tooltip: {
      text: this.t("reports.actions.copy-url")
    }
  }), "data-sentry-element": "AsyncButtonEl", "data-sentry-source-file": "template.tsx" }, this.attr("show-shortlink-text") ? this.t("reports.actions.copy-url") : ""));
}
